module.exports = __webpack_public_path__ + "img/image02.c628904f.jpg";